import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/supplier',
  component: () => import('@views/Supplier/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'supplier',
      name: 'supplier.index',
      component: () => import('@/components/Supplier/Supplier')
    }
  ]
}
